module.exports = __webpack_public_path__ + "static/img/pic-bg-2.7951cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/pic-bg-2.png
// module id = GYjw
// module chunks = 0